import { useCurrentEtudeData } from "components/EtudeForm/hooks/useCurrentEtudeData";
import Button from "components/shared/button";
import { Text } from "components/shared/text";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import {
  useUpdateDHPDataMutation,
  useUpdateProjectTraceMutation,
} from "store/api";
import { ProjectTrace } from "types/ProjectTrace";
import {
  getLocalStorageTraceId,
  setLocalStorageTraceId,
} from "utils/helpers/localStorage";
import MapValuesToProjectTrace from "utils/helpers/projectTrace";
import { useAuth } from "utils/hooks/useAuth";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import {
  getEncodedSolutionID,
  getSolutionNomDeProposition,
} from "../SolutionDetails/helpers";

export const ActionBlockItemTop: React.FC<{
  solution: Solution;
}> = ({ solution }) => {
  const navigate = useNavigate();
  const { network } = useSalesNetwork();
  const { t } = useTranslation();
  const { pac } = solution;
  const [updateProjectTrace] = useUpdateProjectTraceMutation();
  const { installationType, service, json } = useCurrentEtudeData();
  const [updateDHPData] = useUpdateDHPDataMutation();
  const { isInternal } = useAuth();

  const onTraceProject = useCallback(async () => {
    let id = getLocalStorageTraceId();

    let projectTrace: ProjectTrace = MapValuesToProjectTrace(
      {
        Id: id || 0,
        network: network?.code,
        installationType,
        service,
        systeme: json?.systeme,
        quoteEquipments: solution?.panier.map((item) => item.code),
        ...solution,
        ...json,
      },
      t
    );

    let project = await updateProjectTrace(projectTrace);

    if (project?.data?.id) {
      setLocalStorageTraceId(project.data.id);
    }
  }, [installationType, service, json, solution, t, updateProjectTrace]);

  const onUpdateDHPData = useCallback(async () => {
    const pac = solution.panier.find((item) => item.tag === "HP");

    let data: DHPData = {
      object: `${json.siteName}/${json.city}/${pac?.quantite}`,
      commercialReference: pac?.code.toString(),
    };
    await updateDHPData({ data });
  }, [json, solution, updateDHPData]);

  return (
    <div
      className="item custom"
      data-border="inset"
      data-length="260"
      data-background="main-background"
    >
      <group
        data-direction="column"
        data-align="center"
        data-gap="10"
        data-space="20"
        data-space-top="0"
      >
        <group
          data-name="title"
          data-length="180"
          data-height="45"
          data-align="center"
          data-justify="center"
          data-gap="5"
          data-background="accent-xtralight"
          data-radius-bottom="10"
        >
          <text data-uppercase="" data-weight="600" data-wrap="wrap" data-space-horizontal="10" data-text-align="center" data-color="grey-color-dark">
            {getSolutionNomDeProposition(solution)}
          </text>
        </group>
        <Button
          primary
          data-radius="3"
          data-height="40"
          data-space="5"
          data-weight="500"
          icon="check"
          onClick={() => {
            onTraceProject();
            !isInternal && onUpdateDHPData();
            navigate(`${getEncodedSolutionID(solution)}/accessoires`, {
              relative: "route",
            });
          }}
        >
          <Text data-width="auto">FO_SOLUTION_PROPOSITION_BUTTON</Text>
        </Button>
        <group>
          <Button
            fit
            accent
            data-radius="3"
            data-height="40"
            icon="visibility"
            onClick={() => {
              onTraceProject();
              navigate(getEncodedSolutionID(solution), {
                relative: "route",
              });
            }}
          >
            <Text data-width="auto">FO_RESULT_SOLUTION_DETAILS</Text>
          </Button>
        </group>
        <group
          data-space-vertical="20"
          data-justify="center"
          data-scroll-state="show"
          className="picContainer"
        >
          <group
            data-ratio="5:4"
            data-shrink="no"
            data-contain=""
            data-length="170"
          // data-height="200"
          // data-fit="fit"
          >
            <picture data-object-fit="contain">
              {pac.previewUrl ? (
                <img src={pac.previewUrl} alt="" />
              ) : (
                <>no preview </>
              )}
            </picture>
          </group>
        </group>
      </group>
    </div>
  );
};
